const al = {
  shake_title: 'Shake dhe Fito',
  shake_start_shaking: 'Shake telefonin',
  shake_chose_gifts_desc: '',
  shake_choose_gift: 'Zgjidh çfare të pëlqen…',
  shake_again_tomorrow: 'Shake përsëri nesër',
  shake_buy_another_today: 'Dëshiron të Shake përsëri?',
  shake_another_left_today: 'Ke dhe një Shake tjetër për sot',
  shake_button_continue: 'Vazhdo',
  shake_button_redeem: 'Aktivizo',
  shake_button_buy: 'Bli',
  shake_button_go_back: 'Kthehu',
  shake_button_try_again: 'Try again',
  shake_button_customer_support: 'Shërbimi i klientit',
  shake_button_recharge: 'Recharge',
  shake_button_close: 'Mbyll',
  shake_button_error_general: 'Dicka nuk funksionoi',
  shake_back_to_dashboard: 'Kthehu',
  shake_button_upgrade_gift: 'Po, vazhdo për %1$s %2$s',
  shake_button_continue_free: 'Jo, aktivizo dhuratën falas.',
  shake_button_yes_continue: 'Po, vazhdo',
  shake_price_unit: '%1$s %2$s',
  shake_you_selected: 'Ti ke zgjedhur %1$s',
  shake_you_selected_promo: 'Ti ke zgjedhur %1$s për %2$s %3$s',
  shake_multiply_selected: 'Dëshiron të perfishosh %1$s për vetëm %2$s %3$s?',
  shake_zbulo_ofertat: 'Zbulo ofertat',
  shake_re_shake: 'Shake përsëri',
  shake_free_gift: 'Dhurata',
  shake_shake_again: 'Shake sërisht',
  shake_again_amount_vcoins: '%1$s %2$s to shake',
  shake_quote_share: 'Share',
  shake_explore_offers_title: 'Zbulo ofertat',
  shake_explore_offers_desc: 'Kontrollo listën e ofertave të vlefshme  vetëm për ty!',
  shake_no_credit: 'Ti nuk ke kredit të mjaftueshëm',
  shake_loan_credit: 'Dëshiron të marrësh kredit hua %1$s %2$s?',
  shake_loan_limit: 'Ti ke arritur limitin e huasë',
  shake_fitove_product: '%1$s',
  shake_try_now: 'Provo tani',
  shake_later_today: 'Provo më vonë',
  shake_not_enough_vcoins: 'Ti nuk ke mjaftueshëm VCoins',
  shake_not_enough_balance: 'Kredit i pamjaftueshëm',
  shake_got_to_recharge: 'Rimbush',
  shake_label_coupon: 'Kupon',
  shake_label_vcoins: 'VCoins',
  shake_label_quote: 'Shprehje',
  shake_modal_header_info: 'Info',
  shake_url_info: 'https://api-web-ci-vfal.vodafone.com/file/shake/more_info/Shake_Info_AL.html',
  shake_web_start_shaking: 'Shake'
}

export default al
